/**
 * The additions-mode "Propose more sections" trigger, for a page that places it
 * in its own action row instead of letting `OutlineProposalArea` render it on a
 * row of its own. Pair it with `<OutlineProposalArea additionsTrigger="external">`.
 *
 * Renders only while the area is idle: while a proposal is generating, failed
 * (the area shows "Try again") or under review, the area owns the controls and
 * a second trigger here would compete with them.
 */

import { Button } from '@/components/ui/button'
import { GradientSparkleIcon } from '@/components/extraction/GradientSparkleIcon'
import { selectIsProposalIdle, useOutlineProposalStore } from '@/stores/outline-proposal-store'

interface ProposeMoreSectionsButtonProps {
  artifactId: string
}

export function ProposeMoreSectionsButton({ artifactId }: ProposeMoreSectionsButtonProps) {
  const isIdle = useOutlineProposalStore(selectIsProposalIdle)
  const start = useOutlineProposalStore((s) => s.start)

  if (!isIdle) return null

  return (
    <Button variant="ai-ghost" size="sm" onClick={() => void start(artifactId)}>
      <GradientSparkleIcon className="h-4 w-4 mr-2" />
      Propose more sections
    </Button>
  )
}
